import { defineComponent as _defineComponent } from 'vue'
import {
        ref,
        onMounted,
        unref,
        computed,
    } from 'vue';
    import moment from 'moment';
    import { wordEnding } from '@ve/services/textModifiers';
    import { initCommonPromoTooltip } from '@/js/common/services/promoService';

    import { THotelCardRightBlock } from './types/index';
    import SearchPageHotelCardRightBlockPriceToolTip from './components/SearchPageHotelCardRightBlockPriceToolTip.vue';
    import SearchPageHotelCardRightBlockRedirectButton from './components/SearchPageHotelCardRightBlockRedirectButton.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPageHotelCardRightBlock',
  props: {
    hotelCardRightBlockData: null
  },
  setup(__props: any) {

const props = __props as { hotelCardRightBlockData: THotelCardRightBlock };

    

    const tooltipWrapper = ref<HTMLElement | null>(null);

    const isPromoTooltipVisible = computed(() => !!props.hotelCardRightBlockData.promoSegmentId);
    const adults = computed(() => props.hotelCardRightBlockData.touristGroup.adults);
    const kids = computed(() => props.hotelCardRightBlockData.touristGroup.kids);
    const infants = computed(() => props.hotelCardRightBlockData.touristGroup.infants);
    const checkInDateFormatted = computed(() => moment(props.hotelCardRightBlockData.checkInDate, 'YYYY-MM-DD').format('DD MMMM'));
    const nights = computed(() => props.hotelCardRightBlockData.nights);
    const kidsAndInfantsSum = computed(() => unref(kids) + unref(infants));

    onMounted(() => {
        if (unref(isPromoTooltipVisible)) {
            initCommonPromoTooltip(tooltipWrapper.value);
        }
    });

    const touristGroupAdultsText = computed(() => `${unref(adults)} взросл${wordEnding(unref(adults), ('ый;ых;ых'))}`);
    const touristGroupKidsText = computed(() => `и ${unref(kidsAndInfantsSum)} ${wordEnding(unref(kidsAndInfantsSum), ('ребенок;детей;детей'))}`);
    const touristGroupInfantsText = computed(() => `и ${unref(infants)} ${wordEnding(unref(infants), ('младенец;младенца;младенца'))}`);
    const dateText = computed(() => `c ${unref(checkInDateFormatted)} на ${unref(nights)} ноч${wordEnding(unref(nights), ('ь;и;ей;'))}`);

return { __sfc: true,props, tooltipWrapper, isPromoTooltipVisible, adults, kids, infants, checkInDateFormatted, nights, kidsAndInfantsSum, touristGroupAdultsText, touristGroupKidsText, touristGroupInfantsText, dateText, SearchPageHotelCardRightBlockPriceToolTip, SearchPageHotelCardRightBlockRedirectButton }
}

})